import ContentLoader from 'components/content/ContentLoader';

const ScenarioItemSkeleton = () => (
    <div className='display-flex width-100pct align-items-center justify-content-between bg-white p-10'>
        <ContentLoader height='14px' width='80%' />
        <div className='display-flex align-items-center justify-content-center rounded-xl border p-5'>
            <span className='rioglyph rioglyph-play text-16 text-gray-darkest' />
        </div>
    </div>
);

export default ScenarioItemSkeleton;
